import React from 'react'
import Useletter from '../Useletter'
import Foter from '../Foter'
function Us() {
  return (
    <div>
              <h3 style={{marginBottom:"35px",marginTop:"35px",fontFamily:"Alata,sans serif",fontSize:"26px",marginLeft:"20px",textAlign:"left"}} >ABOUT US</h3>

      <div className="bout" style={{display:"flex"}}>

        <div className="bout1" >
        <p style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginTop:"15px",marginLeft:"20px"}}>J. was established in 2002 with a unique philosophy to revive the country's cultural heritage and make Shalwar Kameez; the popular wear, and soon became one of the most famous and recognizable clothing brands in South East Asia.</p>
        <p style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginTop:"15px",marginLeft:"20px"}}>It expanded its store network to 100+ outlets nationwide. J. has further expanded globally by opening 20 outlets in the UK, Australia, Canada, New Zealand, UAE, Qatar, to name a few.</p>
        <p style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginTop:"15px",marginLeft:"20px"}}>We pride ourselves on being a complete apparel brand that deals in eastern wear, perfumes, footwear and accessories for women and men of all ages. We work in different categories and textures like silk, chiffon, cotton, cambric, lawn and fabrics that suit the season.</p>
        <p style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginTop:"15px",marginLeft:"20px"}}>Our clothing line reflects current fashion trends with modest detailing. Designs are inspired from Renaissance, Aztec, Fusion, Arabian and other aesthetics.</p>
        <p style={{textAlign:"left",fontFamily:"Alata,sans serif",fontSize:"14px",marginTop:"15px",marginLeft:"20px"}}>From the humble beginnings of a brand that believed in being Soully East, we have moved forward with more decorative touches to our portfolio and have strung together a loyal base of customers all over the world</p>
        </div>
        <div className="bout2" >
        <img src="https://www.junaidjamshed.com/media/wysiwyg/about_us_1.jpg" width="570" height="500"/>
        </div>
      </div>
      <h3 style={{marginBottom:"35px",marginTop:"35px",fontFamily:"Alata,sans serif",fontSize:"26px",marginLeft:"20px",textAlign:"left"}} >THIS IS J.</h3>

      <video 
        style={{ width: "800px", maxWidth: "100%" }}
        controls
        playsInline
        autoPlay
        muted
        loop
      >
        <source src="https://www.junaidjamshed.com/media/j.mp4" type="video/mp4" />
      </video>

      <Useletter/>
      <Foter/>

      
    </div>
  )
}

export default Us
